module.exports = __webpack_public_path__ + "static/malinowski-logo-ed6c4d360e10c23b92bd31d6d551f9b9.svg";